/**
 * 书架本地存储模块（同步）
 */

export function loadCategories(state) {
  const saved = localStorage.getItem('bookCategories');
  if (saved) {
    try {
      state.categories = JSON.parse(saved);
    } catch (e) {
      state.categories = [];
    }
  }
  state.books.forEach(book => {
    if (book.category && !state.categories.includes(book.category)) {
      state.categories.push(book.category);
    }
  });
  saveCategories(state);
}

export function saveCategories(state) {
  localStorage.setItem('bookCategories', JSON.stringify(state.categories));
}

export function loadCollections(state) {
  let collections = [];
  let membership = {};
  try {
    const raw = localStorage.getItem('bookCollections');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) collections = parsed;
    }
  } catch (e) {}

  try {
    const raw = localStorage.getItem('collectionMembership');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') membership = parsed;
    }
  } catch (e) {}

  const cleanedCollections = (Array.isArray(collections) ? collections : [])
    .map((c) => {
      if (!c) return null;
      const id = String(c.id || '').trim();
      const name = String(c.name || '').trim();
      if (!id || !name) return null;
      const createdAt = c.createdAt ? String(c.createdAt) : new Date().toISOString();
      return { id, name, createdAt };
    })
    .filter(Boolean);

  const collectionIdSet = new Set(cleanedCollections.map(c => String(c.id)));
  const cleanedMembership = {};
  Object.keys(membership || {}).forEach((key) => {
    const cid = String(key || '').trim();
    if (!cid || !collectionIdSet.has(cid)) return;
    const ids = membership[key];
    cleanedMembership[cid] = Array.isArray(ids) ? ids.filter(Boolean).map(String) : [];
  });

  cleanedCollections.forEach((c) => {
    if (!Array.isArray(cleanedMembership[c.id])) cleanedMembership[c.id] = [];
  });

  state.collections = cleanedCollections;
  state.collectionMembership = cleanedMembership;

  if (state.filterCollection !== 'all' && !collectionIdSet.has(String(state.filterCollection))) {
    state.filterCollection = 'all';
  }

  saveCollections(state);
}

export function saveCollections(state) {
  try {
    localStorage.setItem('bookCollections', JSON.stringify(Array.isArray(state.collections) ? state.collections : []));
  } catch (e) {}
  try {
    localStorage.setItem('collectionMembership', JSON.stringify(state.collectionMembership || {}));
  } catch (e) {}
}

export function loadBooklists(state) {
  let lists = [];
  let membership = {};
  let order = [];

  try {
    const raw = localStorage.getItem('booklists');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) lists = parsed;
    }
  } catch (e) {}

  try {
    const raw = localStorage.getItem('booklistMembership');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') membership = parsed;
    }
  } catch (e) {}

  try {
    const raw = localStorage.getItem('booklistOrder');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) order = parsed.map(String);
    }
  } catch (e) {}

  const cleanedLists = (Array.isArray(lists) ? lists : [])
    .map((l) => {
      if (!l) return null;
      const id = String(l.id || '').trim();
      const name = String(l.name || '').trim();
      if (!id || !name) return null;
      const createdAt = l.createdAt ? String(l.createdAt) : new Date().toISOString();
      return { id, name, createdAt };
    })
    .filter(Boolean);

  const listIdSet = new Set(cleanedLists.map(l => String(l.id)));
  const cleanedMembership = {};
  Object.keys(membership || {}).forEach((key) => {
    const lid = String(key || '').trim();
    if (!lid || !listIdSet.has(lid)) return;
    const ids = membership[key];
    cleanedMembership[lid] = Array.isArray(ids) ? ids.filter(Boolean).map(String) : [];
  });

  cleanedLists.forEach((l) => {
    if (!Array.isArray(cleanedMembership[l.id])) cleanedMembership[l.id] = [];
  });

  const ordered = Array.isArray(order) ? order.map(String).filter(id => listIdSet.has(String(id))) : [];
  const orderedSet = new Set();
  const dedupedOrder = [];
  ordered.forEach((id) => {
    const key = String(id);
    if (!key || orderedSet.has(key)) return;
    orderedSet.add(key);
    dedupedOrder.push(key);
  });
  cleanedLists.forEach((l) => {
    const id = String(l.id);
    if (orderedSet.has(id)) return;
    orderedSet.add(id);
    dedupedOrder.push(id);
  });

  state.booklists = cleanedLists;
  state.booklistMembership = cleanedMembership;
  state.booklistOrder = dedupedOrder;

  if (state.booklist?.currentBooklistId && !listIdSet.has(String(state.booklist.currentBooklistId))) {
    state.booklist.currentBooklistId = null;
  }

  saveBooklists(state);
}

export function saveBooklists(state) {
  try {
    localStorage.setItem('booklists', JSON.stringify(Array.isArray(state.booklists) ? state.booklists : []));
  } catch (e) {}
  try {
    localStorage.setItem('booklistMembership', JSON.stringify(state.booklistMembership || {}));
  } catch (e) {}
  try {
    localStorage.setItem('booklistOrder', JSON.stringify(Array.isArray(state.booklistOrder) ? state.booklistOrder : []));
  } catch (e) {}
}

export function loadGlobalShelfOrder(state) {
  let order = [];
  const saved = localStorage.getItem('globalShelfOrder');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) order = parsed.map(String);
    } catch (e) {}
  }
  state.globalShelfOrder = order;
}

export function saveGlobalShelfOrder(state) {
  localStorage.setItem('globalShelfOrder', JSON.stringify(state.globalShelfOrder || []));
}

export function updateGlobalShelfOrderForCollectionOrder(state, orderedCollectionIds) {
  const ids = Array.isArray(orderedCollectionIds) ? orderedCollectionIds.map(String).filter(Boolean) : [];
  const newKeys = ids.map(id => `collection:${id}`);
  if (!newKeys.length) return;

  const current = Array.isArray(state.globalShelfOrder) ? state.globalShelfOrder.map(String) : [];
  const hasCollectionSlots = current.some(k => String(k).startsWith('collection:'));

  let nextOrder = [];
  if (!hasCollectionSlots) {
    nextOrder = [...newKeys, ...current.filter(k => !String(k).startsWith('collection:'))];
  } else {
    let i = 0;
    const set = new Set(newKeys);
    nextOrder = current.map(k => {
      const key = String(k);
      if (!key.startsWith('collection:')) return key;
      if (!set.has(key)) return key;
      if (i >= newKeys.length) return key;
      const next = newKeys[i];
      i += 1;
      return next;
    });
    const existing = new Set(nextOrder.filter(Boolean).map(String));
    newKeys.forEach(k => {
      if (!existing.has(k)) nextOrder.push(k);
    });
  }

  const seen = new Set();
  const deduped = [];
  nextOrder.forEach(k => {
    const key = String(k || '');
    if (!key) return;
    if (seen.has(key)) return;
    seen.add(key);
    deduped.push(key);
  });

  state.globalShelfOrder = deduped;
  saveGlobalShelfOrder(state);
}

export function generateCollectionId() {
  const rand = Math.random().toString(16).slice(2);
  return `col_${Date.now()}_${rand}`;
}

export function generateBooklistId() {
  const rand = Math.random().toString(16).slice(2);
  return `list_${Date.now()}_${rand}`;
}
